import React from 'react';
import { Bot } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-950 text-slate-300 py-10 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="bg-brand-600 p-1.5 rounded-lg">
            <Bot className="h-5 w-5 text-white" />
          </div>
          <span className="font-bold text-white text-lg">Sales Agent AI</span>
        </div>

        <p className="text-sm text-slate-400">
          Jedna oferta: transparentny koszt AI i oszczędność vs etat.
        </p>

        <p className="text-sm text-slate-500">© {new Date().getFullYear()} Sales Agent AI</p>
      </div>
    </footer>
  );
};

export default Footer;
